import $ from 'jquery';

const swipeTreshold = { x: 30, y: 30 };

const gallery = elem => {
    const $prev = elem.find('.gallery__button--prev');
    const $next = elem.find('.gallery__button--next');
    const $indicatorDots = elem.find('.gallery__dot');

    const data = {
        item: 0,
        count: elem.find('.gallery__item').length,
        startMousePos: { x: -1, y: -1 },
        endMousePos: { x: -1, y: -1 },
    };

    selectItem(elem, data);

    $prev.off('click');
    $prev.on('click', function () {
        prevImage(elem, data);
    });
    $next.off('click');
    $next.on('click', function () {
        nextImage(elem, data);
    });
    $indicatorDots.off('click');
    $indicatorDots.on('click', function () {
        data.item = $(this).data('index');
        selectItem(elem, data);
    });

    elem.off('touchstart');
    elem.on('touchstart', function (event) {
        onTouchStart(event, data);
    });
    elem.off('touchend');
    elem.on('touchend', function (event) {
        onTouchEnd(elem, event, data);
    });
};

function indicator(element, data) {
    element.find('.gallery__dot--active').removeClass('gallery__dot--active');
    $(element.find('.gallery__dot').get(data.item)).addClass('gallery__dot--active');
}

function prevImage(element, data) {
    data.item--;
    if (data.item < 0) {
        data.item = data.count - 1;
    }
    selectItem(element, data);
}

function nextImage(element, data) {
    data.item++;
    if (data.item >= data.count) {
        data.item = 0;
    }
    selectItem(element, data);
}

function selectItem(element, data) {
    const $activeItem = element.find('.gallery__item--active');

    if ($activeItem.length) {
        $activeItem.animate({ opacity: 0 }, 100, 'linear', function () {
            $(this).removeClass('gallery__item--active');
            $(element.find('.gallery__item').get(data.item))
                .addClass('gallery__item--active')
                .animate({ opacity: 1 }, 100, 'linear');
        });
    } else {
        $(element.find('.gallery__item').get(data.item))
            .addClass('gallery__item--active')
            .animate({ opacity: 1 }, 100, 'linear');
    }

    indicator(element, data);
}

function onTouchStart(event, data) {
    const evt = typeof event.originalEvent === undefined ? event : event.originalEvent;
    const touch = evt.touches[0] || evt.changedTouches[0];
    data.startMousePos.x = touch.pageX;
    data.startMousePos.y = touch.pageY;
}

function onTouchEnd(element, event, data) {
    const evt = typeof event.originalEvent === undefined ? event : event.originalEvent;
    const touch = evt.touches[0] || evt.changedTouches[0];
    data.endMousePos.x = touch.pageX;
    data.endMousePos.y = touch.pageY;

    const mousePosDiff = {
        x: data.startMousePos.x - data.endMousePos.x,
        y: data.startMousePos.y - data.endMousePos.y,
    };

    data.startMousePos = { x: -1, y: -1 };
    data.endMousePos = { x: -1, y: -1 };

    if (Math.abs(mousePosDiff.x) > swipeTreshold.x) {
        if (mousePosDiff.x > 0) {
            nextImage(element, data);
        } else {
            prevImage(element, data);
        }
    }
}

export const reloadScriptGallery = () => {
    const $elem = $('.gallery');

    if ($elem.length > 0) {
        $elem.each(function () {
            gallery($(this));
        });
    }
};
reloadScriptGallery();
